import React from 'react';
import { Home, CreditCard, Wrench } from 'lucide-react';
import { ROUTES } from '@repo/shared-types/routeRegistry';
import { useAppPathname } from '../../navigation/useAppPathname';

type TenantTab = {
  id: string;
  label: string;
  route: string;
  icon: React.ElementType;
};

const TABS: TenantTab[] = [
  { id: 'my-home', label: 'Home', route: ROUTES.MY_HOME, icon: Home },
  { id: 'payments', label: 'Pay', route: ROUTES.MY_PAYMENTS, icon: CreditCard },
  { id: 'maintenance', label: 'Maintenance', route: ROUTES.MY_MAINTENANCE, icon: Wrench },
];

export interface TenantMobileNavProps {
  onNavigate: (path: string) => void;
}

/**
 * Tenant-only bottom navigation (mobile). Uses app navigate() — no raw history APIs.
 */
export const TenantMobileNav: React.FC<TenantMobileNavProps> = ({ onNavigate }) => {
  const pathname = useAppPathname();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 flex border-t border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900 md:hidden"
      aria-label="Tenant navigation"
    >
      {TABS.map((tab) => {
        const active = pathname === tab.route || pathname.startsWith(`${tab.route}/`);
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onNavigate(tab.route)}
            className={`flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-xs font-medium transition ${
              active
                ? 'text-brand-600 dark:text-brand-400'
                : 'text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white'
            }`}
          >
            <Icon size={20} aria-hidden />
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
};
